module.exports = __webpack_public_path__ + "img/coaching-equipe.90b41716.jpg";